import moment from "moment";

/** A UTC date-time in the user's local time, as CRM stores created and modified times. */
export function convertUTCDateTimeToLocal(date: moment.MomentInput) {
  return date ? moment.utc(date).local() : null;
}

/** A local date-time as UTC with no zone, the form CRM reads and writes. */
export function convertLocalDateTimeToUTC(value: string) {
  return value ? moment(value).utc().format("YYYY-MM-DDTHH:mm:ss") : "";
}

/** A local date-time kept as local time with no zone, for a value stored that way. */
export function toLocalDateTimeValue(value: string | Date) {
  return value ? moment(value).format("YYYY-MM-DDTHH:mm:ss") : "";
}

export function toDate(value: string | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
}

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

/** Formats a value for a native `<input type="date">`'s `value` attribute (yyyy-MM-dd). */
export function toDateInputValue(value: string | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) {
    return "";
  }

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** Formats a value for read-only display (dd/mm/yyyy). */
export function toDisplayDate(value: string | Date | null | undefined): string {
  const date = toDate(value);
  return date ? date.toLocaleDateString("en-GB") : "";
}

/** Formats a value for read-only display, full date and time (dd/mm/yyyy, hh:mm:ss). */
export function toDisplayDateTime(value: string | Date | null | undefined): string {
  const date = toDate(value);
  return date
    ? date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })
    : "";
}

/** Formats a value for a native `<input type="datetime-local">`'s `value` attribute. */
export function toDateTimeInputValue(
  value: string | Date | null | undefined
): string {
  const date = toDate(value);
  if (!date) {
    return "";
  }

  return `${toDateInputValue(date)}T${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}`;
}
